import * as React from 'react'
import { ReactElement } from 'react'
import { DocumentCommandBarItemProps, DocumentSelectionType, overflowButtonStyles, visibleButtonStyles } from './DocumentCommandBar'
import { CommandBarButton, getId } from '@fluentui/react'
import CreateFolderDialog from '../../Dialog/CreateFolder/CreateFolderDialog'
import { IDocumentStackItemDto, isFolder } from '../../../config/documentConfig'
import DialogButton from '../../Button/DialogButton'
import { useTranslation } from 'react-i18next'

export default function CreateFolderButton(props: DocumentCommandBarItemProps): ReactElement {
    const { t: translate } = useTranslation()

    return (
        <DialogButton
            button={CommandBarButton}
            buttonProps={{
                disabled: !props.rootFolder.loaded,
                iconProps: { iconName: 'FabricNewFolder' },
                styles: props.item.renderedInOverflow ? overflowButtonStyles : visibleButtonStyles,
            }}
            dialog={CreateFolderDialog}
            dialogProps={{
                key: getId(),
                isRoot: props.selectionType === DocumentSelectionType.None,
                parent: props.selectionType === DocumentSelectionType.None ? props.rootFolder.data : props.selectedItems.find(isFolder),
                reset: (stack?: IDocumentStackItemDto[]) => props.reset(props.sortOrder, stack),
            }}
            tooltipProps={{
                content:
                    props.selectionType === DocumentSelectionType.None
                        ? translate('file.pivot.document.create.folder.root')
                        : translate('file.pivot.document.create.folder.sub'),
            }}
        />
    )
}
